// Import the login component you provided
import KMRLLogin from '../components/workers/Login.jsx';

function LoginPage() {
  return <KMRLLogin />;
}

export default LoginPage;